module.exports = __webpack_public_path__ + "img/trial2-2.f7f051ea.png";